import React, {useEffect, useState} from "react";
import "./style.scss";
import PropTypes from "prop-types";
import logoWhite from "../../assets/img/logoWhite.svg";
import accueilImg from "../Home/assets/navItems/accueil.svg";
import accueilImg2 from "../Home/assets/navItems/accueil2.svg";
import CMImg from "../Home/assets/navItems/careManager.svg";
import CMImg2 from "../Home/assets/navItems/careManager2.svg";
import PIImg from "../Home/assets/navItems/pepiteInfos.svg";
import PIImg2 from "../Home/assets/navItems/pepiteInfos2.svg";
import MCImg from "../Home/assets/navItems/monCompte.svg";
import MCImg2 from "../Home/assets/navItems/monCompte2.svg";
import {useHistory} from "react-router-dom";
import arrowBack from "../Home/assets/icon/arrowBack.svg";
import useWindowDimensions from "../../hook/useWindowDimension";
import monCompte from "../Home/Pages/MonCompte";
import {getApiBaseUrl} from "../../utils/baseUrl";

const Nav = ({
                 redirectToOnboarding,
                 handleOpenNavItem,
                 navItem,
                 setShowOfferModal,
                 setDisplayQuestions,
                 setOpenFreeQuestionChatBot,
                 showOfferModal,
                 pagePerso,
                 setIframe,
                 dataUser,
                 openFreeQuestionChatBot,
                 displayQuestions
             }) => {
    const history = useHistory();
    const {width} = useWindowDimensions();

    const page = [
        {title: "accueil", src: accueilImg, src2: accueilImg2},
        {title: "careManager", src: CMImg, src2: CMImg2},
        {title: "pepiteInfos", src: PIImg, src2: PIImg2},
        {title: "monCompte", src: MCImg, src2: MCImg2},
    ];
    const navBackArray = [
        {from: "pepiteInfos-blog", to: "pepiteInfos"},
        {from: "pepiteInfos-fichesPratiques", to: "pepiteInfos"},
        {from: "pepiteInfos-tutos", to: "pepiteInfos"},
        {from: "accueil", to: "careManager"},
        {from: "careManager", to: "careManager"},
    ];
    const handleGoBack = () => {
        if (openFreeQuestionChatBot) {
            setOpenFreeQuestionChatBot(false);
            setShowOfferModal(true);
        } else if (showOfferModal) setShowOfferModal(false);
        else if (displayQuestions) setDisplayQuestions(false);
        else if (width > 599) {
            history.push("/");
            handleOpenNavItem("accueil");
        } else if (navItem === "careManager") {
            setDisplayQuestions(false);
            handleOpenNavItem("careManager");
            history.push("/");
        } else {
            console.log("navitem != caremanger");
            const goToArray = navBackArray.filter((nav) => nav.from == navItem);
            const goToItem = goToArray[0];
            handleOpenNavItem(goToItem.to);
        }
        console.log(navItem, window.location);
    };
    const [showBackIcon, setShowBackIcon] = useState(false);
    useEffect(() => {
        let loc = window.location;
        if (loc.href.includes("case")) setShowBackIcon(true);
    }, []);
    return (
        <header>
            <nav>
                <img
                    className={"arrowBack"}
                    src={arrowBack}
                    onClick={handleGoBack}
                    style={{
                        opacity: (
                            (showOfferModal || openFreeQuestionChatBot || displayQuestions || window.location.href.includes("question")) ? ""
                                : (((navItem === "accueil") && !window.location.href.includes("conversation") ||
                                        (navItem === "pepiteInfos") ||
                                        (navItem === "careManager") ||
                                        (navItem === "monCompte") && (width < 599))
                                    && !showBackIcon)
                                    ? "0"
                                    : ""
                        )
                    }}
                />
                <div className={"logos"}>
                    <a href="#" onClick={() => window.location.reload()}>
                        <img
                            className={"prevandcare iconeSearchMobile"}
                            src={logoWhite}
                            alt="logoPrevCare"/>
                    </a>

                    {pagePerso &&
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            setIframe(true);
                        }}>
                            <img
                                className={"partenaire"}
                                src={`${getApiBaseUrl()}/assets/partenaires/${dataUser.idSociete}-header.png`}
                                alt="logoPartenaire"/>
                        </a>
                    }
                </div>
                <svg onClick={redirectToOnboarding} className={"iconeNav"}
                     width="18" height="19" viewBox="0 0 20 21"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.16699 15.5001H10.8337V13.8334H9.16699V15.5001ZM10.0003 2.16675C5.40033 2.16675 1.66699 5.90008 1.66699 10.5001C1.66699 15.1001 5.40033 18.8334 10.0003 18.8334C14.6003 18.8334 18.3337 15.1001 18.3337 10.5001C18.3337 5.90008 14.6003 2.16675 10.0003 2.16675ZM10.0003 17.1667C6.32533 17.1667 3.33366 14.1751 3.33366 10.5001C3.33366 6.82508 6.32533 3.83341 10.0003 3.83341C13.6753 3.83341 16.667 6.82508 16.667 10.5001C16.667 14.1751 13.6753 17.1667 10.0003 17.1667ZM10.0003 5.50008C8.15866 5.50008 6.66699 6.99175 6.66699 8.83342H8.33366C8.33366 7.91675 9.08366 7.16675 10.0003 7.16675C10.917 7.16675 11.667 7.91675 11.667 8.83342C11.667 10.5001 9.16699 10.2917 9.16699 13.0001H10.8337C10.8337 11.1251 13.3337 10.9167 13.3337 8.83342C13.3337 6.99175 11.842 5.50008 10.0003 5.50008Z"
                        fill="#f8f8f8"/>
                </svg>
                {width > 599 &&
                    <img src={MCImg2}
                         onClick={() => handleOpenNavItem("monCompte")}
                         className={"iconeNav-2"}
                    />
                }
                {width < 599 &&
                    <ul id={"bottom-navbar"}>
                        {page.map((item,) => (
                            <li
                                id={item.title}
                                key={item.title}
                                className={`bottom-navbar-borderTop ${navItem.includes(item.title) ? "activeBottomNavbar" : ""}`}
                                onClick={() => {
                                    // if (item.title == "careManager") Afficher caremanagercolumn;
                                    if (window.location !== ("/")) {
                                        history.push("/");
                                    }
                                    // history.push(`/mobileVersion/${item.title}`);
                                    handleOpenNavItem(item.title);
                                    setShowOfferModal(false);
                                    setDisplayQuestions(false);
                                    setOpenFreeQuestionChatBot(false);
                                }}

                            >
                                <img src={item.src}/>
                            </li>
                        ))}
                    </ul>
                }
            </nav>
        </header>
    );
};

Nav.propTypes = {
    dataUser: PropTypes.object,
    redirectToOnboarding: PropTypes.func,
    handleOpenNavItem: PropTypes.func,
    navItem: PropTypes.string,
    setShowOfferModal: PropTypes.func,
    setDisplayQuestions: PropTypes.func,
    setOpenFreeQuestionChatBot: PropTypes.func,
    showOfferModal: PropTypes.bool,
    displayQuestions: PropTypes.bool,
    pagePerso: PropTypes.bool,
    setIframe: PropTypes.func,
    openFreeQuestionChatBot: PropTypes.bool,
};

export default Nav;